const global = {
	state: {
    loading: true,
    menu: {
      isMobile: false,
      menuMini: true,
      menuDrawer: true,
    },
    extraSidebar: {
      sidebarDrawer: false,
      compSidebar: null
    },
    toolbar: {
      path: '',
      title: '',
      actions: []
    },
    tabs: {
      activeTab: '',
      items: []
    },
    dialog: {
      dialogOpen: false,
      title: '',
      onOk: () => {},
      onCancel: () => {}
    },
    snackbar: {
      active: false,
      texto: 'Se ha guardado correctamente',
      x: null,
      y: 'top',
      timeout: 3000
    }
  },
  getters: {

  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload
    },
    cancelDialog(state) {
      state.dialog.dialogOpen = false
    },
    setDialog(state, payload) {
      state.dialog = {...state.dialog, ...payload}
    },
    setTabs(state, payload) {
      state.tabs = {...state.tabs, ...payload}
    },
    setSnackbar(state, payload) {
      state.snackbar = {...state.snackbar, ...payload}
    },
    setActiveSnackbar(state, disabled) {
      state.snackbar.active = disabled
    },
    setExtraSidebar(state, payload) {
      state.extraSidebar = {...state.extraSidebar, ...payload}
    },
    toolbarOptions(state, payload) {
      state.toolbar = {...state.toolbar, ...payload}
    },
    cleanToolbar(state) {
      state.toolbar = {
        path: '',
        title: '',
        actions: []
      }
    },
    toggleSibebarExtraDrawer(state) {
      state.extraSidebar.sidebarDrawer = !state.extraSidebar.sidebarDrawer
    },
    toggleMenuMini(state) {
      state.menu.menuMini = !state.menu.menuMini
    },
    toggleMenuDrawer(state) {
      state.menu.menuDrawer = !state.menu.menuDrawer
      if (state.menu.isMobile === true && state.menu.menuMini === true) {
        state.menu.menuMini = false
      }
    },
    toggleIsMobile(state, payload) {
      state.menu = {...state.menu, ...payload}
    }
  },
  actions: {

  }
}

export default global